module.exports = __webpack_public_path__ + "h5/img/close.48161ce8.gif";